import { WishedReward } from '../redux/wishlist/types'

export const findWishedReward = function (wishedRewards: WishedReward[], rewardId: string) {
  return wishedRewards.find((wishlistReward: WishedReward) => wishlistReward.rewardId === rewardId) !== undefined
}
